import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * LanguageProvider reducer
 *
 */
import ACTIONTYPES from './actionTypes';
import ReduxActionTypes from '../Redux/actionTypes';
import { localStorage } from '../../utils/BrowserStorageUtils';

/**
 * User preferences reducer
 * @param {*} state the current state.
 * @param {*} action a valid user preferences action.
 * @returns {state} the next state.
 */
function userPreferencesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ACTIONTYPES.CHANGE_LANGUAGE:
      {
        localStorage.setItem('selectedLanguage', action.selectedLanguage);
        return _Object$assign({}, state, {
          selectedLanguage: action.selectedLanguage
        });
      }
    case ReduxActionTypes.RESET_STORE_AFTER_LOGOUT:
      {
        // The complete state has been cleared on logout, but we want to re-instate
        // the basic configuration for the next user.
        return _Object$assign({}, state, action.initialConfig.userPreferences);
      }
    default:
      return state;
  }
}
export default {
  userPreferencesReducer: userPreferencesReducer
};